import { isoZ, z } from 'my-zod'
import { enumOptionsToObject } from '../../internal/enum-helpers'
import { productLineOptions, RegionOptions } from '../../internal'
import { outfitterWebRolesZEnum } from '../outfitter-user'
import { OutfitterGroupSchemas } from '../../outfitter-account-management'

export const SeverityOptions = ['error', 'warning', 'info', 'success'] as const
export const Severities = enumOptionsToObject(SeverityOptions)
export type Severity = (typeof SeverityOptions)[number]

export const LifecycleStatusOptions = ['draft', 'sent', 'archived'] as const
export const LifecycleStatuses = enumOptionsToObject(LifecycleStatusOptions)
export type LifecycleStatus = (typeof LifecycleStatusOptions)[number]

export const announcementModel = z.object({
  id: z.string().uuid(),
  shortId: z.string(),
  description: z.string(),
  content: z.string().max(144),
  lifecycleStatus: z.enum(LifecycleStatusOptions),
  dismissible: z.boolean(),
  severity: z.enum(SeverityOptions),
  creatorProfileId: z.number(),
  /** This field is for scheduling sending the announcement */
  startDate: isoZ.instant().nullable(),
  /** This field is for scheduling removing the announcement */
  endDate: isoZ.instant().nullable(),
  /** When the announcement was sent */
  sentDate: isoZ.instant().nullable(),
  /** When the announcement was removed */
  removedDate: isoZ.instant().nullable(),
  outfitterIds: z.number().array(),
  regions: z.enum(RegionOptions).array(),
  productLines: z.enum(productLineOptions).array(),
  roles: outfitterWebRolesZEnum.array(),
  featurePackages: z.enum(OutfitterGroupSchemas.OutfitterFeaturePackageOptions).array(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type announcementModel = z.infer<typeof announcementModel>
